import { useQuery } from "@tanstack/react-query";

import { getProgramContracts } from "services";

import { GET_PROGRAM_CONTRACTS_ADMIN } from "consts";

import { ProgramContract } from "models";

export const useGetProgramContractsAdmin = (programId: string) =>
  useQuery<ProgramContract[]>({
    queryKey: [GET_PROGRAM_CONTRACTS_ADMIN, programId],
    queryFn: () => getProgramContracts(programId),
  });
